var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCross18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#727981",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.725 4.28254C13.4325 3.99004 12.96 3.99004 12.6675 4.28254L9.00001 7.94254L5.33251 4.27504C5.04001 3.98254 4.56751 3.98254 4.27501 4.27504C3.98251 4.56754 3.98251 5.04004 4.27501 5.33254L7.94251 9.00004L4.27501 12.6675C3.98251 12.96 3.98251 13.4325 4.27501 13.725C4.56751 14.0175 5.04001 14.0175 5.33251 13.725L9.00001 10.0575L12.6675 13.725C12.96 14.0175 13.4325 14.0175 13.725 13.725C14.0175 13.4325 14.0175 12.96 13.725 12.6675L10.0575 9.00004L13.725 5.33254C14.01 5.04754 14.01 4.56754 13.725 4.28254Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCross18);
export default __webpack_public_path__ + "static/media/CloseCross18.7f44da2e.svg";
export { ForwardRef as ReactComponent };